import {
  Box,
  Button,
  TextField,
  ThemeProvider,
  createTheme,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useState, useEffect } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import AuthGuard from "../../components/AuthGuard";
import { useCookies } from "react-cookie";
import { useLocation } from "react-router-dom";
import swal from "sweetalert";
import { jwtDecode } from "jwt-decode";
import BeatLoader from "react-spinners/BeatLoader";


let theme = createTheme({
  palette: {
    primary: {
      main: "#0052cc",
    },
    secondary: {
      main: "#1A8D90",
    },
  },
});

const Form = ({ callBackAfterSubmit, formData }) => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [cookie, setCookie] = useCookies(["token"]);
  const location = useLocation();
  const [selectedAccountList, setSelectedAccountList] = useState(formData && formData['accounts'] ? formData['accounts'].map(ac => ac.id) : []);
  const [accountList, setAccountList] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [accountListBK, setAccountListBK] = useState([]);
  const [selectedRole, setSelectedRole] = useState(""); // State for selected role
  const [data, setData] = useState({
    full_name: formData ? formData["full_name"] : "",
    username: formData ? formData["username"] : "",
    email: formData ? formData["email"] : "",
    phone: formData ? formData["phone"] : "",
    password: formData ? null : "",
  });
  const decoded = jwtDecode(cookie["token"]);
  const jsonDataParsed = JSON.parse(decoded.userInfo);

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const response = await fetch(
          process.env.REACT_APP_BACKEND_URL + "/role/all",
          {
            headers: {
              Authorization: "Bearer " + cookie["token"],
            },
          }
        );
        if (!response.ok) {
          throw new Error("Failed to fetch roles");
        }
        const rolesData = await response.json();
  
        let filteredRoles = [];
        if (location.pathname.includes("users")) {
          filteredRoles = rolesData.filter(role => role.id === 2);
        } else if (location.pathname.includes("company")) {
          filteredRoles = rolesData.filter(role => role.id === 3 || role.id === 4);
        }
  
        setRoleList(filteredRoles);
          if (formData && formData.role && formData.role.length > 0) {
          setSelectedRole(formData.roles[0].id); 
        } else {
          if (location.pathname.includes("users")) {
            setSelectedRole(2); 
          } else if (location.pathname.includes("company")) {
            setSelectedRole(formData.role.id); 
          }
        }
      } catch (error) {
        console.error("Error fetching roles:", error);
      }
    };
  
    fetchRoles();
  }, [cookie, location.pathname, formData]);
  
  useEffect(() => {
    const fetchAccounts = async () => {
      const data = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/account/all",
        {
          headers: {
            Authorization: "Bearer " + cookie["token"],
          },
        }
      );
      if (data.status !== 200) {
        setCookie("token", null);
        return;
      }
      const json = await data.json();
      if (formData) {
        setAccountList(json.filter(acc => acc.company.id === formData.company.id));
        setAccountListBK(json.filter(acc => acc.company.id === formData.company.id));
      } else {
        setAccountList(json);
        setAccountListBK(json);
      }
    };
    fetchAccounts();
  }, [cookie, formData]);

  const handleRoleChange = (event) => {
    setSelectedRole(event.target.value);
  };

  const [loading, setLoading] = useState(false);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setLoading(true); // Start loading spinner

    const check = Object.keys(data).filter(
      (ky) => ky !== "username" && ky !== "password" && data[ky] === "" && data[ky] !== null
    );
    if (check.length !== 0) {
      swal("Please Enter All Required Fields");
      setLoading(false); // Stop loading spinner on error
      return;
    }
    if (!data.full_name.includes(' ')) {
      swal("Please Enter Your Full Name Separated By Space");
      setLoading(false); // Stop loading spinner on error
      return;
    }
    let roleId;

    if (location.pathname.includes("users")) {
      roleId = 2;
    } else if (location.pathname.includes("company")) {
      roleId = selectedRole; // Use the selected role
    } else {
      roleId = 3; // Default role if none matched
    }

    let jsonData = {
      ...data,
      role: { id: roleId },
      first_time: true,
    };

    if (formData != null) {
      jsonData = { ...jsonData, id: formData["id"], first_time: false };
    }

    if (location.pathname.includes("company")) {
      jsonData = {
        ...jsonData,
        company: { id: jsonDataParsed.companies.id },
        accounts: selectedAccountList.map((ac) => ({ id: ac })),
      };
    }
    const isUpdateOperation = true; // or false if it's a registration

    const successMessage = formData ? "Update successful!" : "Registration successful!";
    
    fetch(process.env.REACT_APP_BACKEND_URL + "/user/add", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + cookie["token"],
        "Content-Type": "application/json",
      },
      body: JSON.stringify(jsonData),
    }).then(async (resp) => {
      const json = await resp.json();
      setLoading(false); // Stop loading spinner after fetch completes

      if ("error" in json) {
        swal("Error", json["message"], "error");
        return;
      }else{
        swal("Success", successMessage, "success"); // Show success message
        callBackAfterSubmit();
      }
    }).catch(() => {
      setLoading(false); // Stop loading spinner on catch
      setCookie("token", null);
    });
  };

  const handleChange = (e) => {
    setData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleAccountChange = (e) => {
    const selectedAccountIds = typeof e.target.value === "string" ? e.target.value.split(",") : e.target.value;
    if (selectedAccountIds.length === 0) {
      setAccountList(accountListBK);
    } else {
      const companyId = accountList.find(acc => acc.id === selectedAccountIds[0])?.company?.id;
      setAccountList(prev => prev.filter(acc => acc.company.id === companyId));
    }
    setSelectedAccountList(selectedAccountIds);
  };

  if (loading) {
    return (
      <Box 
      m="200px"
      mt={"20rem"}
      sx={{
        marginLeft:"600px",
        width: "90%",
        maxWidth: "800px",
        px: "1rem",
        zIndex: 999,
        margin: "0 auto",
      }}
      >
        <BeatLoader
          color={"#198484"}
          loading={true}
          size={30}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </Box>
    );
  }
  return (
    <AuthGuard>
      <Box
        m="20px"
        mt={"5rem"}
        sx={{
          background: "white",
          width: "90%",
          maxWidth: "800px",
          boxSizing: "border-box",
          px: "1rem",
          zIndex: 999,
          margin: "0 auto",
          borderRadius: "15px",
        }}
      >
        <Header
          title={
            formData == null
              ? `CREATE ${location.pathname.includes("users") ? "USER" : "USER"}`
              : `Edit ${location.pathname.includes("users") ? "User" : "User"}`
          }
          subtitle={
            formData == null
              ? `Create a New ${location.pathname.includes("users") ? "User" : "User"} Profile`
              : `Edit ${location.pathname.includes("users") ? "User" : "User"} Profile`
          }
        />
        <ThemeProvider theme={theme}>
          <form onSubmit={handleFormSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                pt: "3rem",
              }}
            >
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Full Name"
                required
                onChange={handleChange}
                value={data["full_name"]}
                name="full_name"
                disabled={formData != null}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="email"
                label="Email"
                required
                onChange={handleChange}
                value={data["email"]}
                name="email"
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                required
                // inputProps={{ type: 'number'}}
                label="Phone Number"
                onChange={handleChange}
                value={data["phone"]}
                name="phone"
                sx={{ gridColumn: "span 2" }}
              />
              {(location.pathname.includes("company")) && (
                <FormControl sx={{ gridColumn: "span 2" }}>
                  <InputLabel>Account</InputLabel>
                  <Select
                    multiple
                    value={selectedAccountList}
                    label="Account"
                    onChange={handleAccountChange}
                    sx={{ gridColumn: "span 4" }}
                  >
                    {jsonDataParsed.roles.name !== "Company Admin" ? (
                      accountList.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.account_number + ' - ' + item.company.name}
                        </MenuItem>
                      ))
                    ) : (
                      accountList.filter(
                        (item) =>
                          item.company &&
                          jsonDataParsed.companies &&
                          item.company.id === jsonDataParsed.companies.id
                      )
                        .map((filteredItem) => (
                          <MenuItem
                            key={filteredItem.id}
                            value={filteredItem.id}
                          >
                            {filteredItem.account_number +
                              " - " +
                              filteredItem.company.name}
                          </MenuItem>
                        ))
                    )}
                  </Select>
                </FormControl>
              )}
              <FormControl sx={{ gridColumn: "span 2" }}>
                <InputLabel>Role</InputLabel>
                <Select
                  value={selectedRole}
                  label="Role"
                  onChange={handleRoleChange}
                  sx={{ gridColumn: "span 4" }}
                >
                  {roleList.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
              <Button type="submit" color="secondary" variant="contained">
                {formData == null ? "Create New User" : "Edit User"}
              </Button>
            </Box>
          </form>
        </ThemeProvider>
      </Box>
    </AuthGuard>
  );
};

export default Form;
